import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "components/Sidebar";
import { Header } from "components/Header";
import { DeviceSize } from "constants/deviceSize";

export const MainLayout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      if (typeof window === "undefined") return;
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setIsSidebarOpen(false);
    }
  }, [isMobile]);

  // На мобилках закрываем сайдбар, когда меняется роут (напр. при клике по Library или Releases)
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  return (
    <LayoutContainer>
      {isMobile && isSidebarOpen && (
        <SidebarOverlay onClick={() => setIsSidebarOpen(false)}>
          <SidebarDrawer onClick={(e) => e.stopPropagation()}>
            <Sidebar isMobileDrawer />
          </SidebarDrawer>
        </SidebarOverlay>
      )}
      <ContentContainer>
        {!isMobile && <Sidebar />}
        <Content>
          <Box>
            <Header
              isMobile={isMobile}
              onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
            />
          </Box>
          <Main id="main-scroll-container">
            <Outlet />
          </Main>
        </Content>
      </ContentContainer>

      <footer>
        <p></p>
      </footer>
    </LayoutContainer>
  );
};

const LayoutContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${props => props.theme.palette.background.base};
  position: relative;

  /* На мобильных учитываем реальную высоту вьюпорта (без браузерного бара)
     и безопасную зону снизу, чтобы нижний бар не уезжал за пределы экрана */
  @supports (height: 100dvh) {
    height: 100dvh;
  }

  padding-bottom: env(safe-area-inset-bottom, 0);
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  padding: 24px 36px;
  height: 100%;
  width: 100%;

  @media (max-width: ${DeviceSize.TabletMedium}) {
    padding: 12px 12px 16px;
    gap: 12px;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
  flex: 1;
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  overflow: auto;
  border-radius: 30px;
  background-color: ${({ theme }) => theme.palette.background.primary};
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  @media (max-width: ${DeviceSize.TabletMedium}) {
    order: 1;
  }
`;

const Box = styled.div`
  width: 100%;
  height: 80px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${DeviceSize.TabletMedium}) {
    height: 64px;
    border-radius: 16px;
    order: 2;
  }
`;

const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(16px);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  z-index: 40;
`;

const SidebarDrawer = styled.div`
  height: 100%;
  max-width: 80vw;
  width: 280px;
  transform: translateX(0);
  animation: slideInFromRight 0.25s ease-out;

  & > * {
    height: 100%;
  }

  @keyframes slideInFromRight {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;